import * as React from "react";
import type { SVGProps } from "react";
const SvgArmenia = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <path
      d="M0 0h1280v720H0z"
      style={{
        fill: "#ec2024",
      }}
    />
    <path
      d="M0 240h1280v240H0z"
      style={{
        fill: "#36499d",
      }}
    />
    <path
      d="M0 480h1280v240H0z"
      style={{
        fill: "#fbb017",
      }}
    />
  </svg>
);
export default SvgArmenia;
